/* eslint-disable react-hooks/exhaustive-deps */

import React, { FC, useContext, useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Alphabets } from '../../Utils/common';
import appContext from '../../appContext';
import QuantityComponent from '../Custom/QuantityButton';
import addImagePhotoIcon from '../../assets/addImagePhotoIcon.svg'
import './style.scss'

interface Props {
  value: any;
  selectedData: any;
  selectedType: string;
  optionIndex: any;
  hasQuantity: boolean;
  setOptionIndex: (e: any) => void;
  storeHistory: (field: string, value: any, type: string, optional?: any) => void;
  setRedoState: (redoState: any) => void;
}

const Options: FC<Props> = ({ hasQuantity, value, selectedType, optionIndex, setOptionIndex, storeHistory, setRedoState }) => {
  const { register, setValue, control, getValues, watch } = useFormContext();
  const { addChoiceTrigger, setAddChoiceTrigger } = useContext(appContext)

  const { fields, append, remove, insert } = useFieldArray({
    control,
    name: "options",
  });

  const move = (sourceIndex: number, destinationIndex: number) => {
    const updatedFields = [...watch('options')];
    const [removed] = updatedFields.splice(sourceIndex, 1);
    updatedFields.splice(destinationIndex, 0, removed);
    storeHistory("options", getValues('options'), 'slides')
    setValue('options', updatedFields);
    setOptionIndex(destinationIndex);
    setRedoState([])
  };

  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }

    const sourceIndex = result.source.index;
    const destinationIndex = result.destination.index;

    move(sourceIndex, destinationIndex);
  };

  const addOption = () => {
    const otherIndex = fields.findIndex((field: any) => field?.type === "otherField");
    if (otherIndex !== -1) {
      insert(otherIndex, value[0]);
    } else {
      append(value[0]);
    }
    setOptionIndex(watch(`options`).length - 1);
  };

  const setOptionValue = (index: number, value: string) => {
    if (["select", "multi-select", "image-multi-select", "image-select"].includes(selectedType)) {
      setValue(`options[${index}].label`, value);
      setValue(`options[${index}].value`, value);
    }
  };
  useEffect(() => {
    setOptionIndex(0);
  }, []);

  useEffect(() => {
    if (addChoiceTrigger) {
      addOption();
      setAddChoiceTrigger(false);
    }
  }, [addChoiceTrigger])

  const renderDragIcon = (index: number) => {
    if (watch("isYesNo")) return <React.Fragment />;
    if (watch("options")?.length > 1) {
      return (
        <>
          <span
            onClick={() => {
              remove(index);
            }}
            className={"close"}
          >
            <svg
              height="10"
              width="10"
              preserveAspectRatio="xMidYMin slice"
              viewBox="0 0 9.2 9.2"
            >
              <path d="M4.6 3.2L7.8 0l1.4 1.4L6 4.6l3.2 3.2-1.4 1.4L4.6 6 1.4 9.2 0 7.8l3.2-3.2L0 1.4 1.4 0l3.2 3.2z"></path>
            </svg>
          </span>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="40" height="40" fill="#8FB8CA" />
            <mask
              id="mask0_188_10103"
              maskUnits="userSpaceOnUse"
              x="4"
              y="4"
              width="32"
              height="32"
            >
              <rect x="4" y="4" width="32" height="32" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_188_10103)">
              <path
                d="M20 17.4935C19.6449 17.4935 19.3475 17.3732 19.1077 17.1325C18.867 16.8927 18.7467 16.5953 18.7467 16.2402V12.2924L17.3681 13.671C17.1175 13.9217 16.8201 14.047 16.4758 14.047C16.1308 14.047 15.8329 13.9217 15.5822 13.671C15.3316 13.4204 15.2063 13.1225 15.2063 12.7774C15.2063 12.4332 15.3316 12.1358 15.5822 11.8851L19.1227 8.34465C19.248 8.21932 19.3838 8.13034 19.53 8.0777C19.6762 8.0259 19.8329 8 20 8C20.1671 8 20.3238 8.0259 20.47 8.0777C20.6162 8.13034 20.752 8.21932 20.8773 8.34465L24.4491 11.9164C24.6997 12.1671 24.8201 12.4645 24.81 12.8088C24.7992 13.1538 24.6684 13.4517 24.4178 13.7023C24.1671 13.953 23.8642 14.0783 23.5091 14.0783C23.154 14.0783 22.8512 13.953 22.6005 13.7023L21.2533 12.2924V16.2402C21.2533 16.5953 21.1334 16.8927 20.8936 17.1325C20.6529 17.3732 20.3551 17.4935 20 17.4935ZM20 32C19.8329 32 19.6762 31.9737 19.53 31.921C19.3838 31.8692 19.248 31.7807 19.1227 31.6553L15.5509 28.0836C15.3003 27.8329 15.1804 27.535 15.1912 27.19C15.2013 26.8457 15.3316 26.5483 15.5822 26.2976C15.8329 26.047 16.1412 25.9162 16.5072 25.9054C16.8723 25.8954 17.1697 26.0261 17.3995 26.2976L18.7467 27.7076V23.7598C18.7467 23.4047 18.867 23.1068 19.1077 22.8662C19.3475 22.6264 19.6449 22.5065 20 22.5065C20.3551 22.5065 20.6529 22.6264 20.8936 22.8662C21.1334 23.1068 21.2533 23.4047 21.2533 23.7598V27.7076L22.6319 26.2976C22.8616 26.047 23.154 25.9217 23.5091 25.9217C23.8642 25.9217 24.1671 26.047 24.4178 26.2976C24.6684 26.5483 24.7937 26.8512 24.7937 27.2063C24.7937 27.5614 24.6684 27.8642 24.4178 28.1149L20.8773 31.6553C20.752 31.7807 20.6162 31.8692 20.47 31.921C20.3238 31.9737 20.1671 32 20 32ZM26.2976 24.4178C26.047 24.1671 25.9162 23.8588 25.9054 23.4928C25.8954 23.1277 26.0261 22.8303 26.2976 22.6005L27.7076 21.2533H23.7598C23.4047 21.2533 23.1073 21.1329 22.8675 20.8923C22.6268 20.6525 22.5065 20.3551 22.5065 20C22.5065 19.6449 22.6268 19.347 22.8675 19.1064C23.1073 18.8666 23.4047 18.7467 23.7598 18.7467H27.7076L26.2976 17.3681C26.047 17.1384 25.9217 16.846 25.9217 16.4909C25.9217 16.1358 26.047 15.8329 26.2976 15.5822C26.5483 15.3316 26.8512 15.2063 27.2063 15.2063C27.5614 15.2063 27.8642 15.3316 28.1149 15.5822L31.6553 19.1227C31.7807 19.248 31.8697 19.3838 31.9223 19.53C31.9741 19.6762 32 19.8329 32 20C32 20.1671 31.9741 20.3238 31.9223 20.47C31.8697 20.6162 31.7807 20.752 31.6553 20.8773L28.0836 24.4491C27.8329 24.6997 27.5355 24.8196 27.1912 24.8088C26.8462 24.7987 26.5483 24.6684 26.2976 24.4178ZM11.8851 24.4178L8.34465 20.8773C8.21932 20.752 8.13076 20.6162 8.07896 20.47C8.02632 20.3238 8 20.1671 8 20C8 19.8329 8.02632 19.6762 8.07896 19.53C8.13076 19.3838 8.21932 19.248 8.34465 19.1227L11.9164 15.5509C12.1462 15.3211 12.4336 15.2063 12.7787 15.2063C13.1229 15.2063 13.4204 15.3316 13.671 15.5822C13.9217 15.8329 14.042 16.1358 14.032 16.4909C14.0211 16.846 13.8903 17.1488 13.6397 17.3995L12.2924 18.7467H16.2402C16.5953 18.7467 16.8932 18.8666 17.1338 19.1064C17.3736 19.347 17.4935 19.6449 17.4935 20C17.4935 20.3551 17.3736 20.6525 17.1338 20.8923C16.8932 21.1329 16.5953 21.2533 16.2402 21.2533H12.2924L13.7023 22.6319C13.953 22.8616 14.0783 23.154 14.0783 23.5091C14.0783 23.8642 13.953 24.1671 13.7023 24.4178C13.4517 24.6684 13.1488 24.7937 12.7937 24.7937C12.4386 24.7937 12.1358 24.6684 11.8851 24.4178Z"
                fill="white"
              />
            </g>
          </svg>
        </>
      );
    }

    return <React.Fragment />;
  }

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="fields">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef} className="option-container">
              {fields.map((field: any, index: number) => {
                if (field?.type === 'otherField') {
                  return null
                }
                return (
                  <Draggable key={`options${field?.id}`} draggableId={`option-${index}`} index={index} isDragDisabled={watch("isYesNo")}>
                    {(provided) => (
                      <div
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        className='options'
                        onClick={() => { setOptionIndex(index) }}
                      >
                        {["image-select", "image-multi-select"].includes(selectedType) && <img className="button-img" alt="" src={watch(`options[${index}].img`) ? watch(`options[${index}].img`) : addImagePhotoIcon} height={150} />}
                        <div className='option-image-inner-container'>
                          <div className='optionIndex' >
                            <span className='optionLabel'>{Alphabets[index]}</span>
                          </div>
                          <div
                            {...register(`options[${index}].value`, { required: true })}
                            contentEditable={"true"}
                            suppressContentEditableWarning={true}
                            className='option'
                            onInput={(e: any) => { setOptionValue(index, e.target.textContent) }}
                            dangerouslySetInnerHTML={{ __html: getValues(`options[${index}].value`) }}

                          ></div>
                          {hasQuantity && <QuantityComponent />}
                        </div>
                        {renderDragIcon(index)}
                      </div>
                    )}
                  </Draggable>
                )
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      {getValues('isOtherEnabled') && (
        <div className='options other' draggable={false}>
          <div className='optionIndex'><span className='optionLabel'>{Alphabets[fields?.length - 1]}</span></div>
          <div className='option'>Other</div>
          {hasQuantity && <QuantityComponent />}
        </div>
      )}
    </>
  );
};

export default Options;
